module.exports = __webpack_public_path__ + "static/img/GB-WLS.6ed6805f.svg";